import type { JsonObject } from 'flare-chat-core/contracts';

export interface SourcingAPIPort { search(request: object, options?: { signal?: AbortSignal }): Promise<JsonObject> }
export interface SourcingReceipt {
  response: JsonObject; persisted: boolean; acknowledgment?: unknown;
}

// Declared backend protocol translation; not a readiness or business decision.
const OUTCOMES = new Map([
  ['completed:true', 'completed'], ['partial:true', 'partial'], ['blocked:true', 'blocked'], ['failed:true', 'failed'],
  ['completed:false', 'partial'], ['partial:false', 'partial'], ['blocked:false', 'blocked'], ['failed:false', 'failed'],
] as const);
export const resolveSourcingOutcome = (response: JsonObject) => {
  const acknowledgment = response.session_persistence as JsonObject | undefined;
  const persisted = ['persisted', 'idempotent'].includes(String(acknowledgment?.status));
  const outcome = OUTCOMES.get(`${String(response.final_status)}:${persisted}` as Parameters<typeof OUTCOMES.get>[0]) ?? 'failed';
  return { persisted, acknowledgment, outcome };
};
